import React, { useContext } from 'react';
import './footer.css';
import './minjwwws.css';
import { Link } from 'react-router-dom';
import wiseDrivelogoFooter from '../../assets/images/footer/wiseDrivelogoBlueFooter.png';
import { Divider } from '@mui/material';
import { MyContext } from '../../context';

const Footer = () => {
  const { pageData } = useContext(MyContext);

  return (
    <footer className="footer-container">
      <div className="footer-header">
        <div className="container">
          <div className="foter-header-body">
            <img
              loading="lazy"
              src={wiseDrivelogoFooter}
              alt="logo"
              // style={{ marginBottom: '30px' }}
            />
            <p>{pageData?.footerPage?.subTitle}</p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="footerDetails-container">
          <div className="footerLinks">
            <h6>{pageData?.footerPage?.footerLinkProducts?.header}</h6>
            <ul>
              {pageData?.footerPage?.footerLinkProducts?.links?.map(
                (item, index) => (
                  <li key={index}>
                    {item?.type == 'anchor' && (
                      <a aria-label="" href={item?.link}>
                        {item?.label}
                      </a>
                    )}
                    {item?.type == 'link' && (
                      <Link to={item?.link}>{item?.label}</Link>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="footerLinks">
            <h6>{pageData?.footerPage?.footerLinkCompany?.header}</h6>
            <ul>
              {pageData?.footerPage?.footerLinkCompany?.links?.map(
                (item, index) => (
                  <li key={index}>
                    {item?.type == 'anchor' && (
                      <a aria-label="" href={item?.link}>
                        {item?.label}
                      </a>
                    )}
                    {item?.type === 'link' && item?.link.includes('.apk') ? (
                      <a aria-label="" href={item.link} download>
                        {item.label}
                      </a>
                    ) : (
                      item?.type === 'link' && (
                        <Link to={item.link}>{item.label}</Link>
                      )
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="footerLinks">
            <h6>{pageData?.footerPage?.footerLinkResources?.header}</h6>
            <ul>
              {pageData?.footerPage?.footerLinkResources?.links?.map(
                (item, index) => (
                  <li key={index}>
                    {item?.type == 'anchor' && (
                      <a aria-label="" href={item?.link}>
                        {item?.label}
                      </a>
                    )}
                    {item?.type == 'link' && (
                      <Link to={item?.link}>{item?.label}</Link>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="footerLinks">
            <h6>{pageData?.footerPage?.footerLinkPolicies?.header}</h6>
            <ul>
              {pageData?.footerPage?.footerLinkPolicies?.links?.map(
                (item, index) => (
                  <li key={index}>
                    {item?.type == 'anchor' && (
                      <a aria-label="" href={item?.link}>
                        {item?.label}
                      </a>
                    )}
                    {item?.type == 'link' && (
                      <Link to={item?.link}>{item?.label}</Link>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
        <Divider
          sx={{ marginTop: '3rem', marginBottom: '1rem', borderWidth: '1px' }}
        />
        <div className="footerCopyRightUpdate">
          <p
            style={{ paddingTop: '0px', fontFamily: 'matter' }}
            className="footerCopyRight-web"
          >
            {pageData?.footerPage?.footerCopyRight}
          </p>
          <p
            style={{ paddingTop: '0px', fontFamily: 'matter' }}
            className="footerCopyRight-mobile"
          >
            {pageData?.footerPage?.footerCopyRightMobile}
          </p>
          <div className="footerSocialLinksNew">
            <a
              aria-label=""
              href="https://www.facebook.com/Wisedrivewarranty"
              target="_blank"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 2.5C8.09625 2.5 2.5 8.09625 2.5 15C2.5 21.2388 7.07125 26.41 13.0475 27.3487V18.6125H9.8725V15H13.0475V12.2463C13.0475 9.11375 14.9125 7.38375 17.7688 7.38375C19.1362 7.38375 20.5662 7.6275 20.5662 7.6275V10.7025H18.9912C17.4375 10.7025 16.9537 11.6662 16.9537 12.655V15H20.42L19.8662 18.6125H16.9537V27.3487C22.9287 26.4112 27.5 21.2375 27.5 15C27.5 8.09625 21.9037 2.5 15 2.5Z"
                  fill="#6C6E89"
                />
              </svg>
            </a>
            <a
              aria-label=""
              href="https://twitter.com/wisedrivehq"
              target="_blank"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.7026 7.07015C26.7483 7.49227 25.7363 7.76949 24.7001 7.89265C25.7923 7.23944 26.6098 6.21142 27.0001 5.00015C25.9751 5.61015 24.8514 6.03765 23.6801 6.2689C22.8934 5.42713 21.8506 4.86886 20.7138 4.68088C19.5771 4.49291 18.41 4.68577 17.3942 5.22947C16.3784 5.77317 15.5706 6.63726 15.0965 7.68739C14.6224 8.73753 14.5086 9.91488 14.7726 11.0364C12.694 10.9322 10.6605 10.3921 8.80423 9.45098C6.94793 8.50991 5.31029 7.18896 3.99763 5.5739C3.53299 6.37197 3.28882 7.27919 3.29013 8.20265C3.29013 10.0152 4.21263 11.6164 5.61513 12.5539C4.78514 12.5278 3.97342 12.3036 3.24763 11.9002V11.9652C3.24788 13.1723 3.66559 14.3422 4.42994 15.2765C5.19428 16.2108 6.25823 16.852 7.44138 17.0914C6.6709 17.3002 5.86301 17.331 5.07888 17.1814C5.41246 18.2204 6.06264 19.1292 6.93837 19.7803C7.8141 20.4314 8.87154 20.7924 9.96263 20.8127C8.87823 21.6643 7.6366 22.2939 6.30873 22.6654C4.98086 23.0369 3.59279 23.143 2.22388 22.9777C4.6135 24.5144 7.39525 25.3303 10.2364 25.3277C19.8526 25.3277 25.1114 17.3614 25.1114 10.4527C25.1114 10.2277 25.1051 10.0002 25.0951 9.77765C26.1187 9.03786 27.0021 8.12143 27.7039 7.0714L27.7026 7.07015Z"
                  fill="#6C6E89"
                />
              </svg>
            </a>
            <a
              aria-label=""
              href="https://in.linkedin.com/company/wisedrivewarranty"
              target="_blank"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.9187 22.9238H19.5875V17.7025C19.5875 16.4575 19.5625 14.855 17.85 14.855C16.1137 14.855 15.8488 16.21 15.8488 17.6112V22.9238H12.5162V12.1875H15.7162V13.65H15.76C16.2075 12.8075 17.295 11.9163 18.92 11.9163C22.295 11.9163 22.92 14.1387 22.92 17.03V22.9238H22.9187ZM8.75375 10.7188C8.49944 10.7191 8.24757 10.6692 8.01258 10.572C7.77758 10.4748 7.56408 10.3322 7.38432 10.1523C7.20456 9.97241 7.06207 9.75882 6.96501 9.52377C6.86796 9.28871 6.81826 9.03681 6.81875 8.7825C6.819 8.39979 6.93272 8.02575 7.14555 7.70768C7.35838 7.38961 7.66074 7.14179 8.01441 6.99557C8.36808 6.84934 8.75717 6.81127 9.13248 6.88618C9.50778 6.96108 9.85244 7.14559 10.1229 7.41638C10.3933 7.68717 10.5774 8.03208 10.6518 8.40748C10.7262 8.78288 10.6877 9.17192 10.541 9.5254C10.3943 9.87888 10.1461 10.1809 9.82774 10.3933C9.50939 10.6058 9.13521 10.719 8.7525 10.7188H8.75375ZM10.4237 22.9238H7.0825V12.1875H10.425V22.9238H10.4237ZM24.5875 3.75H5.41125C4.49125 3.75 3.75 4.475 3.75 5.37125V24.6287C3.75 25.525 4.4925 26.25 5.41 26.25H24.5825C25.5 26.25 26.25 25.525 26.25 24.6287V5.37125C26.25 4.475 25.5 3.75 24.5825 3.75H24.5863H24.5875Z"
                  fill="#6C6E89"
                />
              </svg>
            </a>
            <a
              aria-label=""
              href="https://www.instagram.com/Wisedrivewarranty/"
              target="_blank"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2666_8247)">
                  <g clipPath="url(#clip1_2666_8247)">
                    a{' '}
                    <path
                      d="M26.478 10.6151C26.4253 9.41955 26.2319 8.59765 25.955 7.88546C25.6693 7.12948 25.2298 6.45266 24.6539 5.89002C24.0913 5.31862 23.41 4.87461 22.6628 4.59338C21.9464 4.31643 21.1288 4.12311 19.9333 4.07039C18.7289 4.01322 18.3465 4 15.2917 4C12.2369 4 11.8546 4.01322 10.6546 4.06593C9.45907 4.11864 8.63717 4.31214 7.92515 4.58891C7.169 4.87461 6.49218 5.31415 5.92954 5.89002C5.35814 6.45266 4.91431 7.13395 4.6329 7.88116C4.35595 8.59765 4.16263 9.41509 4.10992 10.6106C4.05274 11.815 4.03952 12.1974 4.03952 15.2522C4.03952 18.307 4.05274 18.6894 4.10545 19.8893C4.15816 21.0848 4.35166 21.9067 4.62861 22.6189C4.91431 23.3749 5.35814 24.0517 5.92954 24.6144C6.49218 25.1858 7.17347 25.6298 7.92068 25.911C8.63717 26.188 9.45461 26.3813 10.6503 26.434C11.8501 26.4869 12.2326 26.4999 15.2874 26.4999C18.3422 26.4999 18.7246 26.4869 19.9246 26.434C21.1201 26.3813 21.942 26.188 22.654 25.911C24.1661 25.3264 25.3616 24.1309 25.9462 22.6189C26.223 21.9025 26.4165 21.0848 26.4692 19.8893C26.5219 18.6894 26.5352 18.307 26.5352 15.2522C26.5352 12.1974 26.5307 11.815 26.478 10.6151ZM24.4518 19.8014C24.4034 20.9003 24.2188 21.4937 24.065 21.8892C23.6869 22.8694 22.909 23.6474 21.9288 24.0255C21.5332 24.1793 20.9355 24.3639 19.8409 24.4121C18.6542 24.465 18.2983 24.4781 15.2962 24.4781C12.2941 24.4781 11.9337 24.465 10.7512 24.4121C9.6524 24.3639 9.05902 24.1793 8.66344 24.0255C8.17565 23.8452 7.73165 23.5595 7.37126 23.1859C6.99765 22.821 6.71195 22.3815 6.53167 21.8937C6.37783 21.4981 6.19326 20.9003 6.14502 19.8059C6.09213 18.6191 6.07908 18.263 6.07908 15.261C6.07908 12.2589 6.09213 11.8985 6.14502 10.7162C6.19326 9.61734 6.37783 9.02396 6.53167 8.62838C6.71195 8.14042 6.99765 7.69659 7.37572 7.33603C7.7404 6.96242 8.17994 6.67672 8.6679 6.49662C9.06349 6.34278 9.66133 6.1582 10.7557 6.10979C11.9425 6.05708 12.2986 6.04386 15.3005 6.04386C18.307 6.04386 18.6629 6.05708 19.8454 6.10979C20.9443 6.1582 21.5376 6.34278 21.9332 6.49662C22.421 6.67672 22.865 6.96242 23.2254 7.33603C23.599 7.70088 23.8847 8.14042 24.065 8.62838C24.2188 9.02396 24.4034 9.62163 24.4518 10.7162C24.5045 11.9029 24.5177 12.2589 24.5177 15.261C24.5177 18.263 24.5045 18.6147 24.4518 19.8014Z"
                      fill="#6C6E89"
                    />
                    <path
                      d="M15.2917 9.47266C12.1008 9.47266 9.51178 12.0615 9.51178 15.2526C9.51178 18.4437 12.1008 21.0325 15.2917 21.0325C18.4828 21.0325 21.0717 18.4437 21.0717 15.2526C21.0717 12.0615 18.4828 9.47266 15.2917 9.47266ZM15.2917 19.0019C13.2216 19.0019 11.5424 17.3229 11.5424 15.2526C11.5424 13.1823 13.2216 11.5033 15.2917 11.5033C17.362 11.5033 19.041 13.1823 19.041 15.2526C19.041 17.3229 17.362 19.0019 15.2917 19.0019V19.0019Z"
                      fill="#6C6E89"
                    />
                    <path
                      d="M22.6497 9.24388C22.6497 9.98904 22.0455 10.5932 21.3002 10.5932C20.555 10.5932 19.9508 9.98904 19.9508 9.24388C19.9508 8.49855 20.555 7.89453 21.3002 7.89453C22.0455 7.89453 22.6497 8.49855 22.6497 9.24388V9.24388Z"
                      fill="#6C6E89"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_2666_8247">
                    <rect width="30" height="30" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_2666_8247">
                    <rect
                      width="22.5"
                      height="22.5"
                      fill="white"
                      transform="translate(4 4)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
